function save(sess, event) {
    const {Event} = sess;
    return Event.create(event)
}

export default {
    save,
}